"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var MSExcel = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.ImpureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 1H4.667A.667.667 0 0 0 4 1.667V4.5L10 8l3 1.266L16 8V4.5L10 1Z",
    fill: "#21A366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 4.5h6V8H4V4.5Z",
    fill: "#107C41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.334 1H10v3.5h6V1.667A.666.666 0 0 0 15.334 1Z",
    fill: "#33C481"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 8H4v6.334a.666.666 0 0 0 .667.666h10.667a.666.666 0 0 0 .666-.666V11.5L10 8Z",
    fill: "#185C37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 8h6v3.5h-6V8Z",
    fill: "#107C41"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M8.334 3.5H4V13h4.334A.668.668 0 0 0 9 12.334V4.166a.669.669 0 0 0-.666-.666Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.833 4H4v9.5h3.833a.668.668 0 0 0 .667-.666V4.666A.668.668 0 0 0 7.833 4Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.833 4H4v8.5h3.833a.668.668 0 0 0 .667-.666V4.667A.668.668 0 0 0 7.833 4Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.333 4H4v8.5h3.333A.668.668 0 0 0 8 11.834V4.667A.668.668 0 0 0 7.333 4Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.666 4h6.667A.667.667 0 0 1 8 4.667v6.667a.666.666 0 0 1-.667.666H.667A.666.666 0 0 1 0 11.334V4.667A.667.667 0 0 1 .666 4Z",
    fill: "#107C41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.766 10.5 1.618-2.507L1.902 5.5h1.192l.81 1.593c.073.152.125.264.153.338h.01c.053-.12.11-.237.168-.351l.864-1.58h1.095l-1.52 2.479L6.232 10.5H5.067l-.934-1.75a1.461 1.461 0 0 1-.112-.234h-.014c-.027.08-.063.155-.108.226L2.938 10.5H1.766Z",
    fill: "#fff"
  })));
});
var _default = MSExcel;
exports["default"] = _default;